module.exports = __webpack_public_path__ + "static/media/svg-4.78fd7a96.svg";